import getNextUrl from './getNextUrl.js'
import { bake_cookie } from './cookie.js';
import { getCartData, emptyCartSimple } from './func.js';
import { swalOption } from '../components/swal-opt.js';

function removeSeatsInCart(ticketEid) {
  for (const prop in window.seatsInCartObj) {
    if (window.seatsInCartObj.hasOwnProperty(prop)) {
      if (window.seatsInCartObj[prop] === ticketEid) {
        delete window.seatsInCartObj[prop]
      }
    }
  }
}

function removeTicket(ticketEid, seatEid) {
  return new Promise((resolve, reject) => {
    window.showLoading()

    if (window.num < 2) {
      window.num -= 1
        // window.location.href = '/store/shopping-cart/remove-all/?next=/'
      // $.post('/store/shopping-cart/remove-all/', () => {
      $.post('/store/shopping-cart/remove/ajax/1/item/' + ticketEid, () => {

        $('#mobile-header-timer-seating-chart').TimeCircles().stop()
        emptyCartSimple();
        bake_cookie('seatsInCartObj', window.seatsInCartObj, 1)

        setTimeout(() => window.location.href = getNextUrl(), 2500)

        // reject()
      })
    } else if (ticketEid && seatEid) {
      $.ajax({
				url:
					'/store/shopping-cart/remove/ajax/1/item/' + ticketEid + '/summary/1',
				type: 'GET',
				dataType: 'json',
				success: function (data) {
					$(`[data-ticket-eid="${ticketEid}"]`).prev().remove()
					$(`[data-ticket-eid="${ticketEid}"]`).remove()
					document.querySelector('input[name="orderChecksum"]').value = data.orderChecksum
					if (data && data.cartItemAmountSummary) {
						const cartItemAmountSummary = data.cartItemAmountSummary
						$('#tickets-count-label').html(cartItemAmountSummary.quantityTickets)
            $('#products-count-label').html(cartItemAmountSummary.quantityProducts)
						$('#backend-ticket-total').html(cartItemAmountSummary.ticketTotalDisplay)
						$('#backend-non-ticket-total').html(
							cartItemAmountSummary.nonTicketTotalDisplay,
						)
						data.totalSaved.forEach((one, index) => {
							$(
								'#order-general-saved-details-summary .' + one.labelClass,
							).html('- ' + one.valueDisplay)
						})
						$('#backend-fee-tax').html(cartItemAmountSummary.feeAndTaxTotalDisplay)
						data.feesAndTaxes.forEach((one, index) => {
							$(
								'#order-general-fee-details-summary .' + one.labelClass,
							).html(one.valueDisplay)
						})
						$('#backend-order-total').html(cartItemAmountSummary.orderTotalDisplay)
						$('#backend-order-adjustment').html(
							cartItemAmountSummary.orderAdjustmentDisplay,
						)
						$('#backend-final-total').html(cartItemAmountSummary.finalTotalDisplay)
            const insuranceRow = document.querySelector(`.itemsNonTicket-item[data-type="7"]`)
            if (insuranceRow !== null) {
              insuranceRow.querySelector('.price').textContent = cartItemAmountSummary.insuranceTotalDisplay
              insuranceRow.querySelector('.amount').textContent = cartItemAmountSummary.insuranceTotalDisplay
            }
					}
					updateOrderPaymentSection()
					delete window.seatsInCartObj[seatEid]
					bake_cookie('seatsInCartObj', window.seatsInCartObj, 1)
					window.hideLoading()
					window.num -= 1
					resolve()
				},
				error: function (e) {
					Swal.fire(swalOption(myvars.serverError, false)).then((result) => {
						if (result.value) {
							window.location.reload(true)
						}
					})
				},
			})
    } else {
      $.ajax({
        url: '/store/shopping-cart/remove/ajax/1/item/' + ticketEid,
        type: 'GET',
        dataType: 'html',
        timeout: 60000, // Set your timeout value in milliseconds or 0 for unlimited
        success: (data, textStatus, xhr) => {
          $(`[data-ticket-eid="${ticketEid}"]`).remove()
          removeSeatsInCart(ticketEid)
          bake_cookie('seatsInCartObj', window.seatsInCartObj, 1)
          getCartData()
            // ajaxCartNum()
          window.num -= 1

          window.hideLoading()
          resolve()

          console.info(`success removed ${ticketEid}`)
        },
        error: (jqXHR, textStatus, errorThrown) => {
          if (textStatus === 'timeout') {
            Swal.fire(
              swalOption(myvars.timeoutErrorWhileTicketing, false)
            ).then((result) => {
              if (result.value) {
                window.location.reload(true)
              }
            })
          } else {
            Swal.fire(swalOption(myvars.serverError, false)).then((result) => {
              if (result.value) {
                window.location.reload(true)
              }
            })
          }
          reject(errorThrown)
        },
      })
    }
  })
}

function updateOrderPaymentSection() {
	// this is to distinguish between payment, no payment and refund
	var paymentFlag = $('input[name=paymentFlag]').val()
	var prevPaymentType = $(
		'input[name=orderHelperPaymentMethodId]:checked',
	).val()
	var orderAmount = $('#orderAmount').val()
	var url = '/store/order/fast-payment-ajax-load-payment-section/prev-payment-flag/' +
		paymentFlag + '/prev-payment-type/' + prevPaymentType + '/prev-order-amount/' + orderAmount
	$.ajax({
		url: url,
		type: 'GET',
		success: function (data) {
			$('[data-payment-progress]').hide()
			if (data) {
				$('.orderhelper-column-payment-ajax').html(data)
			}
		},
		error: function (e) {
			console.log('error in updateOrderPaymentSection: ' + e)
		},
	})
}

export default async function removeTicketFromCart(ticketEid, seatEid) {
  try {
    await removeTicket(ticketEid, seatEid)
    if (!isNaN(window.num) && window.num > 0 && typeof loadStripeLibrary === 'function' && (typeof initStripeApplePay === 'function' || typeof initStripeGooglePay === 'function')) {
      const timer = $('#mobile-header-timer-seating-chart').TimeCircles();
      loadStripeLibrary(initStripeApplePay(timer), timer);
      loadStripeLibrary(initStripeGooglePay(timer), timer);
    }
  } catch (error) {
    console.debug(error)
  }
}

async function removeGiftCard(reloadFunc, key) {
  return new Promise((resolve, reject) => {
    window.showLoading()
    $.post('/promotion/gift/end-redeem/ajax/1/key/'+key, () => {
      if (reloadFunc)
        reloadFunc()
      window.hideLoading()
      window.num -= 1

      getCartData()

      resolve()
    })
  })
}

async function removeGiftCardFromCart(reloadFunc, key) {
  try {
    await removeGiftCard(reloadFunc, key)
    if (typeof loadStripeLibrary === 'function' && (typeof initStripeApplePay === 'function' || typeof initStripeGooglePay === 'function')) {
      loadStripeLibrary(initStripeApplePay);
      loadStripeLibrary(initStripeGooglePay);
    }
  } catch (error) {
    console.debug(error)
  }
}

window.removeGiftCardFromCart = removeGiftCardFromCart
